export default "__VITE_ASSET__DrN8ISAW__"